import React from 'react';

export type ModuleKeyContextValue = {
  moduleKey: string;
};

export const ModuleKeyContext = React.createContext<ModuleKeyContextValue>({
  moduleKey: '',
});

export type ModuleKeyProviderProps = {
  moduleKey: string;
  children: React.ReactNode;
};

export const ModuleKeyProvider: React.FC<ModuleKeyProviderProps> = ({
  moduleKey,
  children,
}) => {
  const memoValue = React.useMemo(() => ({ moduleKey }), [moduleKey]);
  return (
    <ModuleKeyContext.Provider value={memoValue}>
      {children}
    </ModuleKeyContext.Provider>
  );
};

export const useModuleKey = () => React.useContext(ModuleKeyContext).moduleKey;
